import React, { useState } from "react";
import { Form, Button, Container, Alert } from "react-bootstrap";
import axiosInstance from "../utilities/axiosInstance.js";

const NewsLetterSubscriptionForm = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const headers = { "Content-Type": "application/json" };

    const data = {
      email: email,
      name: name,
    };

    try {
      setIsLoading(true);

      const response = await axiosInstance.post(
        `email/newsletter/subscribe/`,
        data,
        { headers: headers }
      );
      console.log(response);
      // Handle success response
      if (response.status === 201) {
        setIsLoading(false);
        setMessage({ variant: "success", text: response.message });
        setTimeout(() => {
          setMessage(null);
          setEmail("");
          setName("");
        }, 3000);
      }
    } catch (error) {
      // Handle error response
      setIsLoading(false);
      setMessage({ variant: "danger", text: error.message });
      setTimeout(() => {
        setMessage(null);
      }, 3000);
    }
  };

  return (
    <Container>
      <Form onSubmit={handleSubmit} className="text-left">
        <Form.Group controlId="formName">
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter Your Name"
            required
          />
        </Form.Group>

        <Form.Group controlId="formEmail">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter Email"
            autoComplete="email"
            required
          />
        </Form.Group>

        <Button
          type="submit"
          className="mt-3 w-100"
          disabled={isLoading || email.length === 0}
        >
          {isLoading ? "Subscribing..." : "Subscribe"}
        </Button>
      </Form>

      {message && (
        <Alert
          variant={message.variant}
          className="text-center mt-3"
          onClose={() => setMessage(null)}
          dismissible
        >
          {message.text}
        </Alert>
      )}
    </Container>
  );
};

export default NewsLetterSubscriptionForm;
